export const Pharmacy_GotStudents = 0
export const Pharmacy_DidNotGetStudents = 1
export const Pharmacy_Reminder = 2
export const Pharmacy_Register = 3
export const ChainContact_AfterElection = 4
export const ChainContact_Reminder = 5
export const ChainContact_RegistrationStarted = 6
export const PracticeCoordinator_AfterElection = 7
export const PracticeCoordinator_RegisterPracticePeriod = 8
export const PracticeCoordinator_RegisterStudents = 9
export const PracticeCoordinator_Special = 10
export const Student_AfterElection = 11
export const Student_BeforeElection = 12